import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function TeachingSubjects() {
  return (
    <>
      <Header />
      {/* Inner Slider */}
      <section class="inr-header">
        <div class="container">
          <div class="inr-header-content">
            <h1 class="title">Teaching Subjects</h1>
            <ul class="breadcrumb">
              <li><NavLink to="/">Home</NavLink></li>
              <li> Teaching Subjects</li>
            </ul>
          </div>
        </div>
      </section>
      {/*  Inner Body */}
      <section className="innerBody">
        <div class="container curr-blk them-container">
          <div className="col-12">
            <h1>Teaching Subjects</h1>
          </div>
          <h3 class="subhead">Yoga for Children</h3>
          <div class='row'>
            <div class='col-lg-12'>
              <img src="https://webapi.entab.info/api/image/SMNSB/public/images/yoga.jpg"
                class="img-fluid subjectimg " />
              <p>At SMNS, yoga is more than exercise—it’s a journey of balance, strength, and mindfulness. Through age-appropriate poses, children develop physical awareness, muscle strength, and stability, while learning patience and focus. Even simple balancing activities help them build mental calmness, confidence, and a sense of achievement. For our Prep students, we dedicate a special yoga period to nurture both body and mind.</p>
            </div>
          </div>
          <h3 class="subhead">Physical Training (PT)  </h3>
          <div class='row'>
            <div class='col-lg-12'>
              <img src="https://webapi.entab.info/api/image/SMNSB/public/images/ptSection.jpg"
                class="img-fluid subjectimg " />
              <p>Physical Training is a cornerstone of healthy growth and holistic development. At SMNS, PT enhances strength, stamina, and coordination, while boosting mental health, social skills, and leadership qualities. Regular exercise promotes energy, teamwork, focus, and lifelong healthy habits, ensuring every child flourishes physically, mentally, and socially.</p>
            </div>
          </div>
          <h3 class="subhead">Brain Gym</h3>
          <div class='row'>
            <div class='col-lg-12'>
              <img src="https://webapi.entab.info/api/image/SMNSB/public/images/braingym.jpg"
                class="img-fluid subjectimg " />
              <p>A healthy body powers a healthy mind. SMNS introduces Brain Gym exercises to stimulate both hemispheres of the brain, improving concentration, creativity, communication skills, and confidence. Beginning the day with these exercises helps children relax, focus, and perform better, ensuring their minds stay sharp and agile throughout the day.</p>
            </div>
          </div>
          <h3 class="subhead">Learn with Fun  </h3>
          <div class='row'>
            <div class='col-lg-12'>
              <img src="https://webapi.entab.info/api/image/SMNSB/public/images/learnwithfun.jpg"
                class="img-fluid subjectimg " />
              <p>Learning at SMNS is hands-on, colorful, and full of joy! We use pom-poms, clay, playdough, glass jewels, chalks, and more to make education exciting and meaningful. Children engage all their senses—seeing, touching, moving—and strengthen motor skills, concentration, problem-solving, and creativity. When learning is fun, attention spans grow, knowledge deepens, and confidence blooms.</p>
            </div>
          </div>
          <h3 class="subhead">Storytelling</h3>
          <div class='row'>
            <div class='col-lg-12'>
              <img src="https://webapi.entab.info/api/image/SMNSB/public/images/StoryTelling.jpg"
                class="img-fluid subjectimg " />
              <p>
                Storytelling is one of the oldest and most effective tools for language, imagination, and moral growth. At SMNS, stories help children:
              </p>
              <ul>
                <li>Build <b>language and communication skills</b></li>
                <li>Enhance <b>memory and cognitive thinking</b></li>
                <li>Develop <b>creativity and imagination</b></li>
                <li>Foster <b>cultural awareness and moral values</b></li>
                <li>Boost <b>listening skills and social interaction</b></li>
              </ul>
              <p><i>Through stories, learning becomes a <b>holistic, enjoyable, and meaningful experience.</b></i></p>
            </div>
          </div>
          <h3 class="subhead">Circle Time </h3>
          <div class='row'>
            <div class='col-lg-12'>
              <img src="https://webapi.entab.info/api/image/SMNSB/public/images/Circletime.jpg"
                class="img-fluid subjectimg " />
              <p>Circle Time encourages active participation, listening, and socialization. Children engage in auditory exercises, sensory activities, and fun group interactions, developing attention span, communication skills, and readiness for school. At SMNS, circle time nurtures confidence, teamwork, and a love for learning.</p>
            </div>
          </div>
          <h3 class="subhead">Discipline & Manners  </h3>
          <div class='row'>
            <div class='col-lg-12'>
              <img src="https://webapi.entab.info/api/image/SMNSB/public/images/Diciplin-manners.jpg"
                class="img-fluid subjectimg " />
              <p>Good manners and discipline form the foundation of character. At SMNS, children learn to be respectful, thoughtful, and grateful. Simple acts like saying please and thank you cultivate social awareness, positive behavior, and lifelong respect for others. A dedicated period ensures that discipline becomes a habit, not a rule.</p>
            </div>
          </div>
          <h3 class="subhead">Zero Period  </h3>
          <div class='row'>
            <div class='col-lg-12'>

              <img src="https://webapi.entab.info/api/image/SMNSB/public/images/ZeroPeriod.jpg"
                class="img-fluid subjectimg " />
              <p>Zero Period is a special time for interaction, expression, and exploration. Free from textbooks, children engage in creative activities, talent showcases, and speaking exercises. This period builds self-confidence, logical thinking, and strong bonds with peers and teachers, helping children start the day refreshed, confident, and focused.</p>
            </div>
          </div>
          <h3 class="subhead">Nature Walk</h3>
          <div class='row'>
            <div class='col-lg-12'>
              <img src="https://webapi.entab.info/api/image/SMNSB/public/images/naturewalk.jpg"
                class="img-fluid subjectimg " />
              <p>Nature walks at SMNS are more than a stroll—they are adventures of discovery and imagination. Children explore, observe, and interact with nature, sharpening focus, observation skills, and creativity. Experiencing the outdoors nurtures curiosity, wonder, and a deep appreciation for the world around them.</p>
            </div>
          </div>
          <div className="curriculum-summary mt-5 text-center">
            <h5 className="fw-bold mb-3">At SMNS, every subject, activity, and interaction is designed to create a learning environment where children:</h5>
            <ul className="list-unstyled">
              <li>• Feel loved, safe, and inspired</li>
              <li>• Grow into confident, creative, and compassionate individuals</li>
              <li>• Learn through experience, exploration, and play</li>
            </ul>
            <p className="mt-3 fw-semibold text-primary">
              Because at SMNS, we don’t just teach: we <b>ignite curiosity, nurture talent, and inspire hearts.</b>
            </p>
          </div>
        </div>
      </section>
      <div className="clr100"></div>
      {/* Footer */}
      <Footer />
    </>
  )
}

export default TeachingSubjects